// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/announcement-bar/announcement-bar';
import 'snippets/menu/menu';
import 'snippets/country-switcher/country-switcher';
import 'snippets/mini-cart/mini-cart'; // TODO: include mini cart here for now.
import 'snippets/search-form/search';
import 'snippets/icon/icon';

// Styles
import './_header.scss';

// Optional Features
// import './header/header--sticky';


// -------------------------------------
// Variables
// -------------------------------------

var headerClass = '.header';
var menuClass   = '.menu--default';
var menuToggle  = '.header__link--menu';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {

    // Unless we click inside the header,
    // we probably don't want to have open navs
    $('body').on('click', function(event) {
        if (!$(event.target).closest(menuClass).length && !$(event.target).closest('.header__container').length) {
            $(menuToggle).removeClass('js--isOpen');
            $(headerClass).removeClass('js--isOpen');
            $(menuClass).removeClass('js--isOpen');
        }
    });

    // Open menu on mobile
    $(menuToggle).on('click', function(event) {
        event.preventDefault();

        $(this).toggleClass('js--isOpen');
        $(headerClass).toggleClass('js--isOpen');
        $(menuClass).toggleClass('js--isOpen');
        $('body').toggleClass('noscroll');
    });


    document.addEventListener('keyup', function(e) {
        if (e.key == 27 && $(menuClass).hasClass('js--isOpen') ) {
            $(menuToggle).removeClass('js--isOpen');
            $(headerClass).removeClass('js--isOpen');
            $(menuClass).removeClass('js--isOpen');
            $('body').removeClass('noscroll');
        }
    });


    // // Header Sticky State
    // $(window).scroll(function(){
    //     if($(window).scrollTop() > 0) {
    //         $('.header').addClass('is-sticky');
    //         $('.announcement-bar').addClass('is-sticky');
    //     }else {
    //         $('.header').removeClass('is-sticky');
    //         $('.announcement-bar').removeClass('is-sticky');
    //     }
    // });
});
